import JuzgadoLayout from "../components/JuzgadoLayout";
import { useContext, useEffect, useRef, useState } from "react";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import { FilterValue } from "antd/lib/table/interface";
import { Checkbox, DatePicker, Form, Input, message, Modal, notification, Select, Table } from "antd";
import DataFilter from "../../common/components/DataFilter";
import useConfiguracionJuzgadoApi, { ConfiguracionJuzgado } from "../../juzgado-configuraciones/useJuzgadoConfiguracionApi";
import ActaPreview, { ActaPreviewRef } from "../../infracciones/components/ActaPreview";
import moment from "moment-business-days";
import UsuariosContext from "../../common/contexts/UsuariosContext";
import Paragraph from "antd/lib/typography/Paragraph";
import { useForm } from "antd/lib/form/Form";
import { Descargo } from "../hooks/useDescargosAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion } from "../../configuraciones-produccion/useConfiguracionesProduccionAPI";
import styled from "styled-components";
import useJuzgadoInfraccionApi, { InfraccionJuzgado } from "../hooks/useJuzgadoInfraccionAPI";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";
import useJuzgadoAPI from "../hooks/useJuzgadoAPI";
import { AxiosError } from "axios";
import { lastIndexOf } from "lodash";

// Variable para fecha actual
const now = moment();

const { TextArea } = Input;

// Componentes de estilo
const DataTableStyled = styled.div`
text-align: center;
margin-left: -245px;
padding: 0;
justify-content: center;
  &.table
  {    
    width:1600px;
  }
  &.table th {
    width: 50%;
    //border: 1px solid black;
  }  
`;
const FieldsStyled = styled.div`
text-align: center;
&.green {
        color: green;
    }
&.red {
        color: red;
    }
&.blue {
        color: blue;
    }
`;

const JuzgadoList = () => {    
    const api = useConfiguracionJuzgadoApi();
    const apiJuzgado = useJuzgadoAPI();
    const apiJuzgadoInfraccion = useJuzgadoInfraccionApi();    
    const apiLoteImpresion = useLotesImpresionAPI();
    const apiConfiguracionesProduccion = useConfiguracionesProduccionAPI();    
    const refTable = useRef<DataTableRef>(null!);
    const [ idFilterForm ] = Form.useForm();
    const [ patenteFilterForm ] = Form.useForm();
    const [ cuilFilterForm ] = Form.useForm();
    const [ direccionFilterForm ] = Form.useForm();
    const [ vencimientoCallCenterForm ] = Form.useForm();
    const [ infractorFilterForm ] = Form.useForm();
    const [ form ] = useForm<Descargo>();
    const [ archivo, setArchivo ] = useState([]);    
    const [ infractor, setInfractor ] = useState<InfraccionJuzgado>();    
    const [ configuracionJuzgado, setConfiguracionJuzgado ] = useState<ConfiguracionJuzgado>();
    const [ configuracionProduccion, setConfiguracionProduccion ] = useState<ConfiguracionProduccion | undefined>();
    const [ configuracionProduccionId, setConfiguracionProduccionId ] = useState<number | undefined>();
    const [ loadingSendFile, setLoadingSendFile ] = useState<boolean>(false);       
    const [ modalDescargo, setModalDescargo ] = useState<boolean>(false);
    const [ modalDescargoInfraccion, setModalDescargoInfraccion ] = useState<InfraccionJuzgado>();
    const [ spinVisible, setSpinVisible ] = useState<boolean>(false);
    const [ infraccionPdfUrl, setInfraccionPdfUrl ] = useState<string>();  
    const [formValues, setFormValues] = useState<Descargo>();
    const [ dniFilterForm ] = Form.useForm();
    const [ configuracion, setConfiguracion ] = useState<ConfiguracionJuzgado>();
    const [ periodo, setPeriodo ] = useState<number>(0);
    const [loading, setLoading] = useState<Boolean>(false);
    const [ notificacionJuzgado, setNotificacionJuzgado ] = useState<string>();    
    const [ notificacion, setNotificacion ] = useState<boolean>(false);
    const usersContext = useContext(UsuariosContext);
    const actaPreviewRef = useRef<ActaPreviewRef>(null!);
    // Hooks
    useEffect(() => {        
        api.list({ $filter: [`Id eq ${usersContext.user!.juzgadoConfiguracionId}`] }).then(response => {
            setConfiguracionJuzgado(response.data?.value[0]);
        });        
    }, []);            
    useEffect(() => {        
        apiConfiguracionesProduccion.list({ $filter: [`Id eq ${configuracionProduccionId}`], $expand: ["CodigoInfraccion"] }).then(result => {
            setConfiguracionProduccion(result.data?.value[0]);
        });        
    }, [configuracionProduccionId]);
    useEffect(() => {        
        setInfractor(modalDescargoInfraccion);
    }, [modalDescargoInfraccion]);
    useEffect(() => {        
        setConfiguracionProduccionId(infractor?.Equipo.ConfiguracionProduccionId);
    }, [infractor]);

    // Funciones
    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Id != null ? `Id eq ${filters!.Id[0]}` : "",
            filters?.["Titular/NombreCompletoTitular"] !== null ? `contains(Titular/NombreCompletoTitular,'${filters!["Titular/NombreCompletoTitular"]![0]}')` : "",
            filters?.["Titular/PatenteVehiculo"] !== null ? `contains(Titular/PatenteVehiculo,'${filters!["Titular/PatenteVehiculo"]![0]}')` : "",
            filters?.["Titular/CuilTitular"] !== null ? `contains(Titular/CuilTitular,'${filters!["Titular/CuilTitular"]![0]}')` : "",
            filters?.["Titular/DireccionCompletaTitular"] !== null ? `contains(Titular/DireccionCompletaTitular,'${filters!["Titular/DireccionCompletaTitular"]![0]}')` : "",
            filters?.["Titular/DocumentoTitular"] != null ? `contains(Titular/DocumentoTitular,'${filters!["Titular/DocumentoTitular"]![0]}')` : "",
            filters?.["CallCenter"] !== null ? `EstadoPago eq 'IMPAGA' and FechaVencimientoCallCenter le now()` : "",
            ];
    };
    const getHabilitacion = (fecha: string) => {
        const f1 = new Date();
        const dia = Number(fecha.split("/")[0]);
        const mes = Number(fecha.split("/")[1]);
        const anio = Number(fecha.split("/")[2]);
        const f2 = new Date(anio, mes - 1, dia);
        if (f1 > f2) {
            return true;
        }
        if (f1 <= f2) {
            return false;
        }
    };
    const downloadLastPrint = async (id: number, titularId: number) => {
        actaPreviewRef.current.setInfraccionId('');
        actaPreviewRef.current.setInfraccionEstado('');
        actaPreviewRef.current.setTitularId(titularId);
        actaPreviewRef.current.setOpen(false);
        try {            
            const response = await apiLoteImpresion.getActaPdf(id);            
            setLoading(false);
            if (response.error) throw Error;
            setInfraccionPdfUrl(response.data?.value);
        }
        catch (e: any | AxiosError) {
            console.log(`Error: ${e}`);
            message.error("Error al descargar el PDF");
            setLoading(false);
        }
    }
    useEffect(() => {
        api.list({ $filter: [`Id eq ${usersContext.user?.juzgadoConfiguracionId}`] }).then(response => {
            setConfiguracion(response.data?.value[0]);            
        });        
    }, []);
    useEffect(() => {
        setPeriodo(configuracion?.PeriodoCallCenter!);        
    }, [configuracion]);
    // Funciones    
    /* const showPdfNotificacionJudicial = async (item: InfraccionJuzgado) => {
    const showPdfNotificacion = async (id: number) => {
        setLoading(true);
        try {            
            const template: string = "SanCosme"; // Pasar un parámetro
            const response = await api.pdfNotificacionJudicial(item.Id, template);
            if (response.error) throw new Error();            
            setNotificacionJuzgado(response.data);
        } catch (error) {
            message.error(`Error al descargar el PDF o no cuenta con permisos suficientes.`);
        }
        setLoading(false);
    }; */
    const handleArchivo = (e: any) => {
        const nombreArchivo: string = e[0]?.name;
        if (nombreArchivo?.split(".").pop()?.toLocaleLowerCase() !== "pdf") {
            message.error("Archivo con extensión no válida o no seleccionado");
            setArchivo([]);
        }
        else {            
            setArchivo(e);
        }        
    };
    const handleChangeColorEstado = (model: InfraccionJuzgado) => {        
            let color;        
            if (model.Estado === "IMPRESION_GENERADA") {
                color = "green";
            }
            else {
                color = "red";
            }
            return color;
    }
    const handleChangeColorEstadoPago = (model: InfraccionJuzgado) => {        
        let color;        
        if (model.EstadoPago === "PAGADA") {
            color = "green";
        }
        else {
            color = "red";
        }
        return color;
    }
    const handleChangeColorFechaVencimiento = (model: InfraccionJuzgado) => {
        const fechaVencida = getHabilitacion(moment(model.FechaVencimientoCallCenter).format("DD/MM/YYYY"));        
        let color;        
        if (fechaVencida === true) {
            color = "green";
        }
        else {
            color = "red";
        }
        return color;
    }    
    // Componente
    return (
        <JuzgadoLayout >
            <ActaPreview ref = {actaPreviewRef} />

            {/* Modal para descargar acta */}
            <Modal
                width = {"90%"}
                style = {{ maxWidth: "1024px" }}
                bodyStyle = {{ height: "80vh", overflow: "auto" }}
                onCancel = { () => setInfraccionPdfUrl(undefined) }
                open = { infraccionPdfUrl !== undefined} 
                destroyOnClose>
                { infraccionPdfUrl && <iframe style = {{ width: "100%", height: "100%" }} src = { `${infraccionPdfUrl}?timestamp=${new Date().getTime()}` } />}
            </Modal>
            <Modal
                width = { "90%" }
                style = {{ maxWidth: "1024px" }}
                bodyStyle = {{ height: "80vh", overflow: "auto" }}
                onCancel = { () => setInfraccionPdfUrl(undefined) }
                visible = { infraccionPdfUrl !== undefined } footer = { null } >
                { infraccionPdfUrl && <iframe style={{ width: "100%", height: "100%" }} src = { `${infraccionPdfUrl}?timestamp=${new Date().getTime()}` } />}
            </Modal>

            {/* Modal para realizar descargo */}
            <Modal
            afterClose = { async () => await refTable.current.loadItems() }
            title = { `Generar descargo - Infracción N° ${modalDescargoInfraccion?.Id}` }
            open = { modalDescargo }
            onCancel = { () => {
                setArchivo([]);
                form.resetFields();
                setModalDescargo(false);
             } }            
            cancelText = "Cancelar"
            okText = "Generar Descargo"            
            onOk = { async () => {
                try{
                    setLoadingSendFile(true);
                    if (form.getFieldValue("NroResolucion") === "") {
                        setArchivo([]);
                        throw Error("Debe proporcionar un valor para Número de Resolución");
                    }
                    let data = new FormData();
                    data.append("FechaPresentacion", form.getFieldValue("FechaPresentacion"));
                    data.append("FechaResolucion", form.getFieldValue("FechaResolucion"));
                    data.append("DocumentoResolucion.NroResolucion", form.getFieldValue("NroResolucion"));
                    data.append("Estado", form.getFieldValue("Estado"));
                    data.append("DescripcionMotivo", form.getFieldValue("DescripcionMotivo"));
                    data.append("DocumentoResolucion.ArchivoDescargo", archivo[0]);
                    data.append("InfraccionId", String(infractor!.Id));
                    const response = await apiJuzgado.createDescargoById(data);
                    if(!response?.error) {
                        notification.success({ message: 'Descargo generado correctamente', duration: 4 });
                    } 
                    else {
                        throw new Error();
                    }
                    
                    setLoadingSendFile(false);
                }
                catch(error: any | AxiosError){
                    notification.error({ message: error.message ? error.message : 'Error al generar el descargo', duration: 4 });
                }
                finally{
                    form.resetFields();
                    setArchivo([]);
                }
                setModalDescargo(false);
            } }
            key = { modalDescargoInfraccion?.Id }
            destroyOnClose
            okButtonProps = {{ disabled: archivo.length === 0 }}
            >
                <Form 
                form = { form }
                layout="vertical" 
                initialValues = {{
                    "FechaPresentacion": now.format("DD/MM/YYYY"),
                    "FechaResolucion": now.format("DD/MM/YYYY"),
                    "NroResolucion": "",
                    "Estado": "ACEPTADO",
                    "DescripcionMotivo": "",
                    "files": archivo
                }}                
                >
                    <Paragraph><strong>Nro. Acta:</strong> { infractor?.Id }</Paragraph>
                    <Paragraph><strong>Nombre y apellido:</strong> { infractor?.Titular.NombreCompletoTitular }</Paragraph>
                    <Paragraph><strong>Dirección:</strong> { infractor?.Titular.DireccionCompletaTitular }</Paragraph>
                    <Paragraph><strong>Patente:</strong> { infractor?.Titular.PatenteVehiculo }</Paragraph>
                    <Paragraph><strong>Infraccion:</strong> { configuracionProduccion?.CodigoInfraccion.Descripcion }</Paragraph>
                    <Form.Item
                    rules = {[{ required: true, message: "Campo requerido" }]}
                    required                    
                    label = { <strong>Fecha de presentación</strong> }
                    >                        
                        <DatePicker style = {{ width: "100%" }} allowClear = { false } defaultValue = { now } name = "FechaPresentacion" onChange = {(date) => form.setFieldValue("FechaPresentacion", date?.format("DD/MM/YYYY HH:mm:ss"))}></DatePicker>
                    </Form.Item>                    
                    <Form.Item
                    rules = {[{ required: true, message: "Campo requerido" }]}
                    required                    
                    label = { <strong>Fecha de Resolución</strong> }
                    >
                        <DatePicker style = {{ width: "100%" }} allowClear = { false } defaultValue = { now } name = "FechaResolucion" onChange = {(date) => form.setFieldValue("FechaResolucion", date?.format("DD/MM/YYYY HH:mm:ss"))}></DatePicker>
                    </Form.Item>                    
                    <Form.Item
                    rules = {[{ required: true, message: "Campo requerido" }]}
                    required
                    name = {"NroResolucion"}
                    label = { <strong>Nro. de Resolución</strong> }
                    style = {{ width: "100%" }}
                    >                        
                        <Input />
                    </Form.Item>                    
                    <Form.Item 
                    name = "Estado"
                    rules = {[{ required: true, message: "Campo requerido" }]}
                    required                    
                    label = { <strong>Estado</strong> }
                    >
                        <Select style = {{ width: "100%" }} onChange = { (estado) => form.setFieldValue("Estado", estado)} defaultValue = { [{ key: 1, value: "ACEPTADO" }] }>
                            {
                                [{ key: 1, value: "ACEPTADO" }, { key: 2, value: "RECHAZADO" }, { key: 3, value: "PENDIENTE" },].map(e => (
                                    <Select.Option key = {e.key} value = {e.value}>{ e.value }</Select.Option>
                                ))
                            }
                        </Select>
                    </Form.Item>                    
                    <Form.Item 
                    name = "DescripcionMotivo"
                    label = { <strong>Descripción del motivo</strong> }
                    >
                        <TextArea placeholder = "Descripción del motivo" rows = { 3 } maxLength = { 500 }></TextArea>
                    </Form.Item>                    
                    <Form.Item
                    label = { <strong>Adjuntar archivo</strong> }
                    required
                    rules = {[{ required: true, message: "Campo requerido" }]}
                    >                        
                        <Input type = "file" name = "files" accept="pdf" onChange = {(e) => handleArchivo(e.target.files)} style = {{ width: "60%" }} onAbortCapture = { (e) => setArchivo([]) }/>
                        {
                            archivo.length === 0 &&
                            <Paragraph style = {{ color: "red" }}>Recepción de archivos en formato PDF</Paragraph>
                        }
                    </Form.Item>
                </Form>
            </Modal>
            <DataTableStyled className = "table">
            <DataTable<InfraccionJuzgado, InfraccionJuzgado>                
                list = { (query) => apiJuzgadoInfraccion.list({ ...query, ...{ $expand: ["Titular", "Equipo"] } }) }
                title = "Infracciones"
                generateFilters = { generateFilters }
                defaultPageSize = { 25 }
                defaultSortOrder = "Id desc"                           
                ref = { refTable }
                itemActions = {[
                    {
                        key: 'download',
                        label: 'Descargar acta impresa',                        
                        action: (item) => {
                            if(item.Estado != 'IMPRESION_GENERADA'){
                                notification.info({message: 'No se puede descargar, solo con impresión generada.'})
                            }
                            else {
                                downloadLastPrint(item.Id, item.TitularId);
                            }
                            return null;
                        }                        
                    },
                    // Opción para notificación por vía judicial
                    /* {
                        label: "Ver notificacion",                        
                        action: (item, sItems) => {
                            if(getHabilitacion(moment(item.Fecha2doVencimiento).format("DD/MM/YYYY")) === false){
                                notification.error({ message: 'No se puede visualizar la notificación, no se encuentra habilitada.' });
                            }
                            else {
                                return showPdfNotificacionJudicial(item);
                                return showPdfNotificacion(item.Id!);
                            }                            
                        },
                        key: 'download'
                    }, */
                    {
                        key: 'subirDescargo',
                        label: "Subir descargo",                        
                        action: (item) => {
                            setModalDescargoInfraccion(item);
                            setModalDescargo(true);
                        }
                    }                    
                ]}
            >
                <Table.Column<InfraccionJuzgado>
                    title = "Fecha Infracción"
                    align = "center"
                    dataIndex = { "Fecha" }                    
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.FechaHora ? moment(record.FechaHora).format("DD/MM/YYYY HH:mm:ss") : "-" }
                        </div>
                    )}                    
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "N° Acta"
                    align = "center"
                    dataIndex = { "Id" }
                    sorter
                    defaultSortOrder = { "descend" }
                    sortDirections = { ["ascend", "descend", "ascend"] }
                    render={(val, record) => {                        
                        return <div style={{ textAlign: 'center' }}>
                          { record.Id ? record.Id : "-"  }
                        </div>
                    }}
                    filterDropdown = { (props) => {                        
                      return (
                        <DataFilter
                          filterDropdownProps={props}
                          form = { idFilterForm }
                        >
                          <Form.Item name = { "Id" } style = { { marginBottom: 10 } }>
                            <Input placeholder = "Nro Acta..." />
                          </Form.Item>
                        </DataFilter>
                      );
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    align = "center"
                    title="Titular"
                    dataIndex={"Titular/NombreCompletoTitular"}
                    sorter
                    defaultSortOrder = { "descend" }
                    sortDirections = { ["ascend", "descend", "ascend"] }
                    render={(val, record) => (
                        <div style={{ textAlign: 'center' }}>
                            { record.Titular?.NombreCompletoTitular ? record.Titular.NombreCompletoTitular : "-" }
                        </div>
                    )}
                    filterDropdown = { (props) => {
                        return (
                            <DataFilter
                            filterDropdownProps = { props }
                            form = { infractorFilterForm }
                            >
                            <Form.Item name = { "NombreCompletoTitular" } style = { { marginBottom: 10 } }>
                                <Input placeholder = "Nombre..." />
                            </Form.Item>
                            </DataFilter>
                        );
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Dominio"
                    align = "center"
                    dataIndex = { "Titular/PatenteVehiculo" }
                    sorter
                    defaultSortOrder = { "descend" }
                    sortDirections = { ["ascend", "descend", "ascend"] }
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.Patente ? record.Patente : "-" }
                        </div>
                    )}
                    filterDropdown = { (props) => (
                        <DataFilter
                        filterDropdownProps = { props }
                        form = { patenteFilterForm }
                        >                            
                            <Form.Item name = { "PatenteVehiculo" } style = { { marginBottom: 10 } }>
                                <Input placeholder = "Patente..." />
                            </Form.Item>
                        </DataFilter>
                    )}
                />                
                <Table.Column<InfraccionJuzgado>                    
                    title = "Cuil/Cuit"
                    align = "center"
                    dataIndex = { "Titular/CuilTitular" }
                    sorter
                    defaultSortOrder = { "descend" }
                    sortDirections = { ["ascend", "descend", "ascend"] }
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.Titular?.CuilTitular ? record.Titular?.CuilTitular : "-" }
                        </div>
                    )}
                    filterDropdown = { (props) => {
                        return (
                            <DataFilter
                            filterDropdownProps = { props }
                            form = { cuilFilterForm }
                            >
                            <Form.Item name = { "CuilTitular" } style = { { marginBottom: 10 } }>
                                <Input placeholder = "Cuil/Cuit..." />
                            </Form.Item>
                            </DataFilter>
                        );
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Direccion"
                    align = "center"
                    dataIndex = { "Titular/DireccionCompletaTitular" }                    
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.Titular?.DireccionCompletaTitular ? record.Titular?.DireccionCompletaTitular : "-" }
                        </div>
                    )}
                    filterDropdown = { (props) => {
                        return (
                            <DataFilter
                            filterDropdownProps = { props }
                            form = { direccionFilterForm }
                            >
                            <Form.Item name = { "DireccionCompletaTitular" } style = { { marginBottom: 10 } }>
                                <Input placeholder = "Direccion..." />
                            </Form.Item>
                            </DataFilter>
                        );
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Localidad"
                    align = "center"
                    dataIndex = { "Titular/LocalidadTitular" }
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            <Paragraph style = {{ width: "130%", textAlign: "center", marginLeft: "-10px" }}>{ record.Titular?.LocalidadTitular ? record.Titular.LocalidadTitular : "-" }</Paragraph>
                        </div>
                    )}                    
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Estado Pago"
                    align = "center"
                    dataIndex = { "EstadoPago" }                    
                    render = {(value, record) => {
                        const color: string = handleChangeColorEstadoPago(record);
                        return(
                            <FieldsStyled className = { color }>
                                {
                                    record.EstadoPago ? record.EstadoPago : "-"
                                }
                            </FieldsStyled>
                        )
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "1° Vencimiento"
                    align = "center"
                    dataIndex = { "FechaVencimiento" }                    
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.FechaVencimiento ? moment(record.FechaVencimiento).format("DD/MM/YYYY") : "-" }
                        </div>
                    )}                    
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "2° Vencimiento"
                    align = "center"
                    dataIndex = { "Fecha2doVencimiento" }                    
                    render = { (val, record) => (
                        <div style = { { textAlign: 'center' } }>
                            { record.Fecha2doVencimiento ? moment(record.Fecha2doVencimiento).format("DD/MM/YYYY") : "-" }
                        </div>
                    )}                    
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Estado"
                    align = "center"
                    dataIndex = { "Estado" }
                    render = {(value, record) => {
                        const color: string = handleChangeColorEstado(record);
                        return(
                            <FieldsStyled className = { color }>
                                {
                                    record.Estado === "IMPRESION_GENERADA" ? "IMPRESA" : "Descartada"
                                }
                            </FieldsStyled>
                        )
                    }}
                />
                <Table.Column<InfraccionJuzgado>                    
                    title = "Vencimiento Call Center"
                    align = "center"
                    dataIndex = { "CallCenter" }                    
                    render = {(value, record) => {
                        const color: string = handleChangeColorFechaVencimiento(record);                        
                        return(
                            <FieldsStyled className = { color }>
                                {
                                    moment(record.FechaVencimientoCallCenter).format("DD/MM/YYYY")
                                }
                            </FieldsStyled>
                        )
                    }}
                    filterDropdown = { (props) => {
                        return (
                            <DataFilter filterDropdownProps = { props } form = { vencimientoCallCenterForm }>                
                                <Form.Item name = {"CallCenter"} style = {{ marginBottom: 10 }} valuePropName = "checked">
                                    <Checkbox>Vencidas</Checkbox>                  
                                </Form.Item>
                            </DataFilter>
                            );
                    }}
                />                
            </DataTable>
            </DataTableStyled>
        </JuzgadoLayout>
    )
}

export default JuzgadoList;